const UNDO_REDO_TOOLTIP = {
    UNDO: 'Undo',
    REDO: 'Redo',
    RESTORING: 'Restoring version...',
    SUGGESTED_EDIT: 'Applying suggested edit...',
    MANUAL_EDIT: 'Saving changes...'
};

const getBusyTooltip = ({ isSuggestedEditRunning, isManualEditProcessing }) => {
    if (isSuggestedEditRunning) return UNDO_REDO_TOOLTIP.SUGGESTED_EDIT;
    if (isManualEditProcessing) return UNDO_REDO_TOOLTIP.MANUAL_EDIT;
    return UNDO_REDO_TOOLTIP.RESTORING;
};

// undo/redo must stay locked while any edit is still being persisted, otherwise it would
// restore a snapshot taken before the pending edit lands
const getUndoRedoButtonState = ({ isUndoLoading, isSuggestedEditRunning, isManualEditProcessing }) => {
    const isUndoRedoLoading = Boolean(isUndoLoading || isSuggestedEditRunning || isManualEditProcessing);
    const busyTooltip = getBusyTooltip({ isSuggestedEditRunning, isManualEditProcessing });

    return {
        isUndoRedoLoading,
        undoTooltip: isUndoRedoLoading ? busyTooltip : UNDO_REDO_TOOLTIP.UNDO,
        redoTooltip: isUndoRedoLoading ? busyTooltip : UNDO_REDO_TOOLTIP.REDO
    };
};

export default getUndoRedoButtonState;
